import React, { Component } from 'react';
import { connect } from 'react-redux';
import './App.css';
import Search from '../components/Search';
import Sort from '../components/Sort';
import ErrorBoundry from '../components/ErrorBoundry';
import UnitList from '../components/unit/UnitList';

import { getParts, searchParts, getSkillInfo, sortParts, changeSortDir, setFilters, changeView, updateStatus } from '../actions';
import Ad from "../components/ad/Ad";

const showFilters = (filters) => {

   document.querySelector('.filters-body').style.display = "block";

   // Reset filters every time we open it
   if ( filters.rarity ) {

      for ( const rarity of filters.rarity ) {

         document.querySelector('.filter-rarity input[data-filtervalue="' + rarity + '"]').checked = true;
      }
   }

   if ( filters.part ) {

      for ( const part of filters.part ) {

         document.querySelector('.filter-part input[data-filtervalue="' + part + '"]').checked = true;
      }
   }

};

const showSkill = (elem) => {

   // Remove mark of newly loaded skills
   if ( elem.classList.contains('rendered') ) {

      elem.classList.remove('rendered');
   }

   if ( elem.classList.contains('hidden') ) {

      elem.classList.remove('hidden');      
   } else {

      elem.style.removeProperty('height');
      elem.classList.add('hidden');
   }   
};

const mapStateToProps = (state) => {

   return {
      searchText: state.getParts.searchText,
      searchResultIds: state.getParts.searchResultIds,
      searchMatchType: state.getParts.searchMatchType,
      listedParts: state.getParts.listedParts,
      listedPartJSONString: state.getParts.listedPartJSONString,
      isPending: state.getParts.isPending,
      error: state.getParts.error,
      availableSkills: state.getInfo.skills,
      pendingSkills: state.getInfo.pendingSkills,
      sortDir: state.getParts.sortDir,
      sortBy: state.getParts.sortBy,
      filters: state.getParts.filters,
      displayView: state.updateUI.displayView,
      statusText: state.updateUI.statusText,
   }
};

const showStatusMessage = (dispatch, text) => {

   dispatch(updateStatus(text));
};

const mapDispatchToProps = (dispatch) => {

   return {
         onSearchChange: async (event, stringToSearch) => {
               
            if ( event.key === 'Enter' ) {

               const matchType = 'or';
               const searchFieldValue = document.querySelector('.search-field').value;
               await showStatusMessage(dispatch, `Searching for "${searchFieldValue}". Please wait...`);
               await setTimeout(() => {

                  searchParts(dispatch, searchFieldValue, stringToSearch, matchType)
               }, 0)
            }
         },
         onStartSearch: async (event, stringToSearch) => {

            const matchType = 'or';
            await showStatusMessage(dispatch, `Searching for "${event.target.value}". Please wait...`);
            const searchFieldValue = document.querySelector('.search-field').value;
            setTimeout(() => {

               searchParts(dispatch, searchFieldValue, stringToSearch, matchType);
            }, 1000);
         },
         onGetParts: async () => {

            showStatusMessage(dispatch, "Loading data. Please wait...");
            getParts(dispatch);
         },
         onGetSkillInfo: (event) => {

            const skillContainer = event.currentTarget.querySelector('.unit-skill');
            const isSkillLoaded = skillContainer.classList.contains('loaded');
            if ( !isSkillLoaded ) {

               skillContainer.classList.add('loading');
               const skillId = event.currentTarget.attributes['data-skid'].value;
               getSkillInfo(dispatch, skillId);
            } else {
            
               showSkill(skillContainer);
            }
         },
         onSortParts: async (event) => {

               const value = event.target.value;
               await showStatusMessage(dispatch, `Sorting. Please wait...`);
               await setTimeout(function() {
                  dispatch(sortParts(value));
               }, 0);
               await setTimeout(function() {
                  showStatusMessage(dispatch, `Sorting Successful!`);
               }, 0);
         },
         onChangeSortDir: async (event) => {

            event.target.classList.toggle('hightolow');
            const sortDir = event.target.classList.contains('hightolow') ? 'hightolow' : 'lowtohigh';
            const sortDirLabel = sortDir === 'hightolow' ? "Highest to Lowest" : "Lowest to Highest";

            await showStatusMessage(dispatch, `Sorting from ${sortDirLabel}. Please wait...`);
            await setTimeout(() => {
               changeSortDir(dispatch, sortDir, sortDirLabel)
            }, 0);
            await setTimeout(function() {
               showStatusMessage(dispatch, `Sorting Successful!`);
            }, 0);
         },
         onSetFilters: () => {

            // Filter Rarity
            const rarityFilter = document.querySelectorAll('.filter-rarity input[type=checkbox]');
            let rarityArray = [];
            for (const rarity of rarityFilter) {

               if (rarity.checked) {

                  rarityArray.push(rarity.dataset.filtervalue);
               }
            }

            // Filter Part
            const partsFilter = document.querySelectorAll('.filter-part input[type=checkbox]:not(.part-weapons):not(.part-pilots)');
            let partsArray = [];
            for (const part of partsFilter) {

               if (part.checked) {

                  partsArray.push(part.dataset.filtervalue);
               }
            }    

            dispatch(setFilters({ rarity: rarityArray, part: partsArray }));
            document.querySelector('.filters-body').style.display = 'none';
         },
         onChangeView: (event) => dispatch(changeView(event.target.value)),
      }
};

class App extends Component {

   componentDidMount() {

      const adjustListingPosition = () => {

         const elementorHeader = document.querySelector('.elementor-location-header');
         const elementorHeaderHeight = elementorHeader != null ? elementorHeader.clientHeight : 0;

         const topBar = document.querySelector('.top-bar');
         const topBarHeight = topBar != null ? topBar.clientHeight : 0;

         document.querySelector('.UnitListContainer').style.paddingTop = topBarHeight + 'px';
         document.querySelector('.UnitListContainer').style.paddingBottom = (elementorHeaderHeight + topBarHeight) + 'px';
      };

      document.addEventListener('DOMContentLoaded', adjustListingPosition);
      window.addEventListener('resize', adjustListingPosition);

      this.props.onGetParts();
   }

   render() {

      const {
         isPending,
         listedParts,
         listedPartJSONString,
         onStartSearch,
         searchText,
         searchResultIds,
         searchMatchType,
         onSearchChange,
         onGetSkillInfo,
         availableSkills,
         pendingSkills,
         onSortParts,
         onChangeSortDir,
         sortDir,
         sortBy,
         onSetFilters,
         filters,
         onChangeView,
         displayView,
         onStatusChange,
         statusText,
      } = this.props;

      return (
         <div className="App">
            <div className={'view--' + displayView + " App-container justify-start"}>
               <ErrorBoundry> 
                  <div className="top-bar shadow-1 w-100 flex-ns flex-wrap-ns">
                     <Search
                        onSearch={onStartSearch}
                        onSearchChange={onSearchChange}
                        listedPartJSONString={listedPartJSONString}
                     />
                     <Sort
                         onSortParts={onSortParts}
                         onChangeSortDir={onChangeSortDir}
                         onSetFilters={onSetFilters}
                         filters={filters}
                         showFilters={showFilters}
                     />
                     <div className='status-text tc f6 blue w-100'>{statusText}</div>
                  </div>
                  <div className='UnitListContainer w-100 tc'>
                     { displayView === 'list' ? <Ad className='fixed right-0' /> : ''}
                     { !isPending ?
                        <UnitList
                           units={listedParts}
                           onGetSkillInfo={onGetSkillInfo}
                           availableSkills={availableSkills}
                           pendingSkills={pendingSkills}
                           sortDir={sortDir}
                           sortBy={sortBy}
                           filters={filters}
                           onChangeView={onChangeView}
                           displayView={displayView}
                           searchResultIds={searchResultIds}
                           searchText={searchText}
                           searchMatchType={searchMatchType}
                           onStatusChange={onStatusChange}
                        /> : ''
                     }
                  </div>
               </ErrorBoundry>
            </div>
         </div>
         )
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
